import { Component, OnInit, Input, Output, EventEmitter, LOCALE_ID, Inject, ViewChild, HostListener } from '@angular/core';
import { formatDate } from '@angular/common';
import { CompanySettingsService } from 'src/app/reusables/services/company-settings.service';
import { CvConfigurationService } from 'src/app/reusables/services/cv-configuration.service';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import { CvNumberLocalizePipe } from 'src/app/reusables/pipes/cv-number-localize.pipe';
import { PointStoreCategoriesService } from '../../services/point-store-categories.service';
import { PointStoreNavigationBarService } from '../../services/point-store-navigation-bar.service';
import { PointStorePermissionService } from '../../services/point-store-permission.service';
import { PointStoreProductCardBaseService } from '../../services/point-store-product-card-base.service';
import { PointStoreProductEditService } from '../../services/point-store-product-edit.service';
import { ShoppingCartService } from '../../../agent-side/services/shopping-cart.service';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'cv-point-store-product-landing-card',
  templateUrl: './point-store-product-landing-card.component.html',
  styleUrls: ['./point-store-product-landing-card.component.scss']
})
export class PointStoreProductLandingCardComponent implements OnInit {

  @Input() product: any;

  @Output() editPointStoreProduct: EventEmitter<any> = new EventEmitter<any>();
  @Output() copyPointStoreProduct: EventEmitter<any> = new EventEmitter<any>();
  @Output() removePointStoreProduct: EventEmitter<any> = new EventEmitter<any>();
  @Output() popoverElementEvent: EventEmitter<any> = new EventEmitter<any>();

  pspes: any = null;
  scs: any = null;
  DateFormat = "MMM d, y";
  LocalizationMessages: any = null;
  public isCxOne: boolean = false;
  picturesLabel:string = "";
  noneLabel:string = "";
  ongoingLabel: string = "";
  offLabel = "";
  isInsidePopover: boolean = false;
  isInsideCard: boolean = false;
  
  constructor(
    @Inject(LOCALE_ID) private locale: string,
    public cvLocalizationService: CVLocalizationService,
    private pointStoreProductEditService: PointStoreProductEditService,
    private shoppingCartService: ShoppingCartService,
    private pointStoreNavigationBarService: PointStoreNavigationBarService,
    private companySettingsService: CompanySettingsService,
    public baseCardService: PointStoreProductCardBaseService,
    public pointStorePermissionService: PointStorePermissionService,
    private cvConfigurationService: CvConfigurationService,
    private pointStoreCategoriesService: PointStoreCategoriesService,
  ) {
    this.isCxOne = cvConfigurationService.isCxOne;
  }
  
  ngOnInit() {
    this.pspes = this.pointStoreProductEditService.pointStoreProductEditObj;
    this.scs = this.shoppingCartService.shoppingCartObj;
    this.loadLocalizationsMessages();
    this.picturesLabel = this.cvLocalizationService.getCachedText("MarketPlace_Management", "Pictures", "Pictures");
    this.noneLabel = this.cvLocalizationService.getCachedText("Common", "None", "None");
    this.ongoingLabel = this.cvLocalizationService.getCachedText("MarketPlace_Management", "Ongoing", "Ongoing");
    this.offLabel = this.cvLocalizationService.getCachedText("MarketPlace_Management", "OFF", "OFF");
  }

  async edit(product: any) {
    const check = await this.baseCardService.checkSinglePermission(this.pointStorePermissionService.getEditPermissionName());
    if (check) {
      this.editPointStoreProduct.emit(product);
      this.pointStoreCategoriesService.resetCategoriesList();
      this.pointStoreNavigationBarService.setWizardIndex(0);
    }
  }

  async copy(product: any) {
    const check = await this.baseCardService.checkSinglePermission(this.pointStorePermissionService.getCreatePermissionName());
    if (check) {
      this.copyPointStoreProduct.emit(product);
      this.pointStoreCategoriesService.resetCategoriesList();
      this.pointStoreNavigationBarService.setWizardIndex(0);
    }
  }

  async remove(product: any) {
    const check = await this.baseCardService.checkSinglePermission(this.pointStorePermissionService.getEditPermissionName());
    if (check) {
      this.removePointStoreProduct.emit(product);
    }
  }

  loadLocalizationsMessages() {
    this.cvLocalizationService.GetSection("MarketPlace_Management_Messages").then(
      (result) => {
        this.LocalizationMessages = result;
      }
    );
  }

  computeSalePrice(product) {
    return Math.ceil(product.Price - ((product.Sale / 100.0) * product.Price));
  };

  displayFlexColumn(product) {
    const rangeString = String(this.getProductPrice(product));
    const res = String(rangeString).trim();
    if (res.includes('-')) {
      return res.length >= 15;
    } else {
      return new CvNumberLocalizePipe().transform(res).length > 8 && product.Sale != null && this.isCurrentSale(product);
    }
  }

  getProductPrice(product) {
    if (product) {
      if (product.HasProductVariations && product.HasVariationPrices && product.VariationsData != null && product.VariationsData.length) {
        let initialVariation = product.VariationsData.reduce((prev, curr) => {
          let prevValue = prev.VariationPrice;
          let currValue = curr.VariationPrice;
          if (prev.VariationOnSale)
            prevValue = prev.VariationPrice - (prev.VariationPrice * (product.Sale / 100));
          if (curr.VariationOnSale)
            currValue = curr.VariationPrice - (curr.VariationPrice * (product.Sale / 100));
          return prevValue < currValue ? prev : curr;
        });
        let lastVariation = product.VariationsData.reduce((prev, curr) => {
          let prevValue = prev.VariationPrice;
          let currValue = curr.VariationPrice;
          if (prev.VariationOnSale)
            prevValue = prev.VariationPrice - (prev.VariationPrice * (product.Sale / 100));
          if (curr.VariationOnSale)
            currValue = curr.VariationPrice - (curr.VariationPrice * (product.Sale / 100));
          return prevValue > currValue ? prev : curr;
        });
        let initialVariationPrice = initialVariation.VariationOnSale ? (initialVariation.VariationPrice - (initialVariation.VariationPrice * (product.Sale / 100))) : initialVariation.VariationPrice;
        let lastVariationPrice = lastVariation.VariationOnSale ? (lastVariation.VariationPrice - (lastVariation.VariationPrice * (product.Sale / 100))) : lastVariation.VariationPrice;
        return new CvNumberLocalizePipe().transform(Math.ceil(initialVariationPrice)) + " - " + new CvNumberLocalizePipe().transform(Math.ceil(lastVariationPrice));
      }
      else if (product.Sale != null && this.isCurrentSale(product)) {
        return this.computeSalePrice(product);
      } else
        return product.Price;
    }
  }

  isCurrentSale(item): any {
    if (typeof item !== 'undefined') {
      return this.shoppingCartService.filterCollectionsByType(item, 1);
    }
  }

  cannotLoadImgText(): string {
    return this.cvLocalizationService.getCachedText("MarketPlace_Management", "Cannot_Load_Image", "Cannot_Load_Image");
  }

  getTitle(product, type) {
    let title = "";
    let onGoingMessage = " - OnGoing";

    if (this.LocalizationMessages != undefined) {
      onGoingMessage = " - " + this.LocalizationMessages.get("OnGoing");
    }

    const coinToCurrencyRatio = this.companySettingsService.getCompanyValueByFieldName("CoinToCurrencyValue");
    switch (type) {
      case "carousel":
        if (product.CarouselStart != null)
          title = formatDate(product.CarouselStart, this.DateFormat, this.locale) + (product.CarouselEnd != null ? (" - " + formatDate(product.CarouselEnd, this.DateFormat, this.locale)) : onGoingMessage);
        break;
      case "featured":
        if (product.FeatureStart != null)
          title = formatDate(product.FeatureStart, this.DateFormat, this.locale) + (product.FeatureEnd != null ? (" - " + formatDate(product.FeatureEnd, this.DateFormat, this.locale)) : onGoingMessage);
        break;
      case "sale":
        if (product.SaleStart != null)
          title = formatDate(product.SaleStart, this.DateFormat, this.locale) + (product.SaleEnd != null ? (" - " + formatDate(product.SaleEnd, this.DateFormat, this.locale)) : onGoingMessage);
        break;
    }
    return title;
  };

  setCurrentPopover(popover: any): void{
    this.popoverElementEvent.emit(popover);    
  }

  async editAssigned(product: any) {
      const check = await this.baseCardService.checkSinglePermission(this.pointStorePermissionService.getEditPermissionName());
      if (check) {
          this.editPointStoreProduct.emit(product);
          this.pointStoreNavigationBarService.setSelectedFrame(6);
          this.pointStoreNavigationBarService.setWizardIndex(3);
      }
  }

  getNumberGroupsAssigned(product) {
      if (product.PointStoreProductAllAssignments.emp.length > 0) {
        let assignedGroups;
        if (product.PointStoreProductAllAssignments.emp.length === 1){
          assignedGroups = this.cvLocalizationService.getCachedText("MarketPlace_Management", "Number_Group_Assigned", "{0} group assigned");
        } else {
          assignedGroups = this.cvLocalizationService.getCachedText("MarketPlace_Management", "Number_Groups_Assigned", "{0} groups assigned");
        }
          let assignedGroupsReplaced = assignedGroups.replace('{0}', product.PointStoreProductAllAssignments.emp.length);
          return assignedGroupsReplaced;
      }
  }

  formatDate(product){
    const startDate = formatDate(product.ProductStart, this.DateFormat, this.locale);
    const endDate = formatDate(product.ProductEnd, this.DateFormat, this.locale);
    const ongoinLabel = this.cvLocalizationService.getCachedText("MarketPlace_Management", "Ongoing", "Ongoing");
    return !product.ProductEnd ? `${startDate} - ${ongoinLabel}` : `${startDate} - ${endDate}` 
  }

  enterCard(popover: NgbPopover) {
    this.isInsideCard = true;
    this.isInsidePopover = false;
    if (this.isInsideCard === true && this.isInsidePopover === false) {
      popover.close();
    }
  }

  leaveCard(popover: NgbPopover) {
    this.isInsideCard = false;

    setTimeout(() => {
      if (this.isInsideCard === false && this.isInsidePopover === false) {
        popover.close();
        return;
      }
    }, 200);
    return;
  }

  openPopover(popover: NgbPopover): void {
    popover.open();
    return;
  }

  changeInsidePopoverFlag(): void {
    this.isInsidePopover = true;
    this.isInsideCard = false;
  }

  leavePopover(popover: NgbPopover): void {
    this.isInsidePopover = false;
    if (!this.isInsideCard) {
      popover.close();
      return;
    }
    return;
  }
}
